export const articledata = [
    { id: 1, questiontypes: 'A & R', easy: '352', easyaccurency: '30%', modurate: '123', modurateaccurency: '30%', difficult: '40', difficultaccurency: '30%', highlydifficult: '40', highlyaccurency: '30%' },
    { id: 2, questiontypes: 'Comprehension', easy: '652', easyaccurency: '30%', modurate: '514', modurateaccurency: '30%', difficult: '40', difficultaccurency: '30%', highlydifficult: '40', highlyaccurency: '30%' },
    { id: 3, questiontypes: 'Diagram', easy: '123', easyaccurency: '30%', modurate: '230', modurateaccurency: '30%', difficult: '40', difficultaccurency: '30%', highlydifficult: '40', highlyaccurency: '30%' },
    { id: 4, questiontypes: 'Formula', easy: '412', easyaccurency: '30%', modurate: '412', modurateaccurency: '30%', difficult: '40', difficultaccurency: '30%', highlydifficult: '40', highlyaccurency: '30%' },
    { id: 5, questiontypes: 'General', easy: '320', easyaccurency: '30%', modurate: '333', modurateaccurency: '30%', difficult: '40', difficultaccurency: '30%', highlydifficult: '40', highlyaccurency: '30%' },
    { id: 6, questiontypes: 'Integer', easy: '366', easyaccurency: '30%', modurate: '525', modurateaccurency: '30%', difficult: '40', difficultaccurency: '30%', highlydifficult: '40', highlyaccurency: '30%' },
];

export const articlecolumns = [
    {
        dataField: "questiontypes",
        text: "Question Types",
        sort: true
    },
    {
        dataField: "easy",
        text: "Easy",
        sort: true
    },
    {
        dataField: "easyaccurency",
        text: "Accurency",
        sort: true
    },
    {
        dataField: "modurate",
        text: "Modurate",
        sort: true
    },
    {
        dataField: "modurateaccurency",
        text: "Accurency",
        sort: true
    },
    {
        dataField: "difficult",
        text: "Difficult",
        sort: true
    },
    {
        dataField: "difficultaccurency",
        text: "Accurency",
        sort: true
    },
    {
        dataField: "highlydifficult",
        text: "Highly Difficult",
        sort: true
    },
    {
        dataField: "highlyaccurency",
        text: "Accurency",
        sort: true
    }
];

export const defaultSorted = [
    {
        dataField: "questiontypes",
        order: "asc"
    }
];

  